<template>
  <CreateEditUserModal
    v-if="showCreateEditUserModal"
    @closeModal="closeCreateEditUserModal"
  />
  <LoadingData v-if="loadData" />
  <div v-else class="card">
    <div class="card-header d-flex align-items-center py-0">
      <h6 class="py-3 mb-0">Usuários</h6>
      <div class="ms-auto">
        <button
          type="button"
          class="btn btn-primary"
          title="Novo Usuário"
          @click="showCreateEditUserModal = true"
        >
          Novo Usuário
        </button>
      </div>
    </div>
    <ListUsers :users="users" />
  </div>
</template>

<script>
import CreateEditUserModal from '@/components/users/CreateEditUserModal.vue'
import LoadingData from '@/components/commons/LoadingData.vue'
import ListUsers from '@/components/users/ListUsers.vue'

export default {
  name: 'Users',

  components: {
    CreateEditUserModal,
    LoadingData,
    ListUsers,
  },

  data() {
    return {
      loadData: true,
      showCreateEditUserModal: false,
      users: [],
    }
  },

  methods: {
    async getUsers() {
      try {
        this.users = await this.$store.dispatch('getUsers')
        this.loadData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    closeCreateEditUserModal(loadListUsers) {
      if (loadListUsers) {
        this.loadData = true
        this.getUsers()
      }
      this.showCreateEditUserModal = false
    },
  },

  mounted() {
    this.getUsers()
  },
}
</script>
